import Modal from "react-modal";
import { useNavigate, useParams } from "react-router-dom";
import "./index.css";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useEffect, useState } from "react";
import { ConfigType } from "../../contexts/AppConfigContext";
import NoImg from "../../assets/images/no-image.png";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useSeller } from "../../hooks/useSeller";
import { useToast } from "../../hooks/useToast";
import { StoreInfo } from "../../pages/StoreInfoCancel/storeInfo";

type ModalProdutoCarrinhoProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  orderIdExt: any;
};

export function ModalCancel({
  isOpen,
  setIsOpen,
  orderIdExt,
}: ModalProdutoCarrinhoProps) {
  const navigate = useNavigate();
  const { pluginspace } = usePluginspace();
  const { pluginspace_id } = useParams();
  const { getAppConfig } = useAppConfig();
  const { getTokenSeller } = useSeller();
  const [isSeller, setIsSeller] = useState(false);
  const [config, setConfig] = useState<ConfigType>();

  const [hasLogin, setHasLogin] = useState<boolean>(true);
  const [isCard, setIsCard] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const [isLandmark, setIsLandmark] = useState(false);
  const [isCounter, setIsCounter] = useState(false);
  const [isInternalDelivery, setIsInternalDelivery] = useState(false);

  const toastComponent = useToast();

  const getLandmark = () => {
    const landmark = localStorage.getItem("landmark_synkar");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem.interval;
    } else {
      return null;
    }
  };

  const getCardNumber = () => {
    return localStorage.getItem("card_number");
  };

  const getCounterNumber = () => {
    return localStorage.getItem("counter_number");
  };

  const getTableNumber = () => {
    return localStorage.getItem("table_number");
  };

  const getInternalNumber = () => {
    return localStorage.getItem("internal_number");
  };

  async function loadConfig() {
    const aux = await getAppConfig();
    setConfig(aux!);
    if (getLandmark()) {
      setIsLandmark(true);
    }
    if (getCounterNumber()) {
      setIsCounter(true);
    }
    if (getCardNumber()) {
      setIsCard(true);
    }
    if (getTableNumber()) {
      setIsTable(true);
    }
    if (getInternalNumber()) {
      setIsInternalDelivery(true);
    }
  }

  function setSeller() {
    const tk = getTokenSeller();
    if (tk && tk.profile == "seller") {
      setIsSeller(true);
    }
  }

  function goToCart() {
    if (
      pluginspace &&
      pluginspace?.appLogin &&
      !isCard &&
      !isTable &&
      !isLandmark &&
      !isCounter &&
      !isSeller &&
      !isInternalDelivery
    ) {
      navigate(`/${pluginspace_id}/new_cart`);
    } else if (
      pluginspace &&
      pluginspace.type !== "food" &&
      !isCard &&
      !isTable &&
      !isLandmark &&
      !isCounter &&
      !isSeller &&
      !isInternalDelivery
    ) {
      navigate(`/${pluginspace_id}/new-cart`);
    } else {
      navigate(`/${pluginspace_id}/cart`);
    }
  }

  useEffect(() => {
    setSeller();
    loadConfig();
  }, []);

  function formatarNomeProduto(str: string): string {
    // Dividir a string em palavras usando espaço como delimitador
    const palavras = str.split(" ");

    // Mapear cada palavra e formatá-la
    const palavrasFormatadas = palavras.map((palavra) => {
      // Transformar a primeira letra em maiúscula e as demais em minúscula
      const primeiraLetra = palavra.charAt(0).toUpperCase();
      const restoPalavra = palavra.slice(1).toLowerCase();
      return primeiraLetra + restoPalavra;
    });

    // Juntar as palavras formatadas de volta em uma única string
    return palavrasFormatadas.join(" ");
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-produto-carrinho"
      contentLabel="Produto adicionado ao carrinho"
      overlayClassName="overlay-modal-carrinho"
      ariaHideApp={false}
    >
      <StoreInfo onClose={() => setIsOpen(false)} orderIdExt={orderIdExt} />
    </Modal>
  );
}
